export default function MeshBackground() {
  return (
    <div className="mesh-bg" aria-hidden="true">
      <div className="mesh-layer mesh-base" />
      <div className="mesh-layer mesh-blue" />
      <div className="mesh-layer mesh-yellow" />
      <div className="mesh-layer mesh-mint" />
      <div className="mesh-layer mesh-lavender" />
      <div className="mesh-noise" />
    </div>
  );
}
